<template>
  <div class="layout-body" :style="{minHeight: bodyHeight}">
    <div class="layout-header-bar">
      <div class="head-logo">
        <img
          src="@assets/img/exhibition/logo.png"
          alt="云展台"
          @click="$router.push('/exhibition/login/alogin')"
          class="f-csp"
        />
      </div>
      <div class="head-right">
        <div class="head-btn" @click="$router.push('/exhibition/login')">返回</div>
      </div>
    </div>
    <div class="register-form">
      <div class="rf-title">用户注册</div>
      <Form
        ref="formInline"
        :model="formInline"
        :rules="ruleInline"
        label-position="right"
        :label-width="100"
        @submit.native.prevent
      >
        <FormItem label="账号：" prop="name">
          <Input type="text" v-model="formInline.name" placeholder="请输入账号" />
        </FormItem>

        <FormItem label="手机号：" prop="mobile">
          <Input type="text" v-model="formInline.mobile" placeholder="请输入手机号" />
        </FormItem>
        <FormItem label="验证码：" class="form-code-item" prop="captcha">
          <Row>
            <Col span="16">
              <Input type="text" v-model="formInline.captcha" placeholder="请填写验证码" />
            </Col>
            <Col span="8">
              <Button v-if="showCode" @click="getCaptcha">获取验证码</Button>
              <Button v-else disabled>{{count}}s后重新获取</Button>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="密码：" prop="password">
          <Input type="password" v-model="formInline.password" placeholder="请输入密码" />
        </FormItem>
        <FormItem label="密码确认：" prop="repassword">
          <Input type="password" v-model="formInline.repassword" placeholder="请再次输入密码" />
        </FormItem>
        <FormItem>
          <Checkbox v-model="agree">
            <span style="padding-left: 4px;">我已阅读并同意</span>
          </Checkbox>
          <span class="form-tip-info" @click="showModel=true">《注册服务条款》</span>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            size="large"
            @click="handleSubmit('formInline')"
            long
            :loading="loading"
          >提交</Button>
        </FormItem>
      </Form>
    </div>
    <iModal v-model="showModel" name="my-modal" footer-hide width="800">
      <h2 style="text-align: center;font-size: 20px;">用户注册服务条款</h2>
      <pre style="padding: 40px 0;white-space: pre-wrap;word-wrap: break-word;">
版本生效日期：2019年2月18日
欢迎“您”（以下或称“用户”）与“慕渊（上海）智能科技有限公司”（下称“慕渊”）共同签署本《用户注册服务条款》协议（下称“本协议”），本协议阐述之条款和条件适用于您使用慕渊基于互联网，以包含慕渊展商秀官方网站（www.zhanshangxiu.com）、展商秀微信端等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。 
一、服务条款的确认和接纳
    1.1 展商秀服务的所有权和运营权归慕渊（上海）智能科技有限公司所有。所提供的服务必须按照其发布的公司章程，服务条款和操作规则严格执行。用户通过完成注册程序并点击一下“我已阅读并同意”的按钮，这表示
    用户与慕渊（上海）智能科技有限公司达成本协议并接受所有的服务条款。
    1.2您在点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。
    1.3当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序，或以任何方式进入慕渊展商秀官方网站并使用服务即表示您已充分阅读、理解并同意接受本协议的条款和条件。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序并停止使用服务。

二、定义
    2.1慕渊：指慕渊（上海）智能科技有限公司，以及关联企业上海联展软件技术有限公司、上海悠逸信息技术有限公司等企业。上海联展软件技术有限公司为本网站注册公司，慕渊（上海）智能科技有限公司为本网站实际经营者。
    2.2慕渊服务：展商秀、会展人、联展、悠逸

三、协议范围
    3.1签约主体
    本协议由您与慕渊共同缔结，本协议对您与慕渊具有同等合同效力。
    3.2补充协议
    由于互联网高速发展，您与慕渊签署的本协议列明的条款并不能完整罗列并覆盖您与慕渊所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，慕渊法律声明、隐私政策、慕渊中国站规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用慕渊服务，视为您同意上述补充协议。
 
四、账户注册与使用
    4.1用户资格
    您确认，在您完成注册程序或以其他慕渊允许的方式实际使用服务时，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的相应后果，且慕渊有权终止向您提供服务并注销您的账户。如您代表一家公司或其他法律主体在慕渊展商秀官方网站注册，则您声明和保证，您有权使该公司或该法律主体受本协议的约束。 
    4.2账户注册
    4.2.1在您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，或在您按照激活页面提示填写信息、阅读并同意本协议且完成全部激活程序后，或您以其他慕渊允许的方式实际使用慕渊服务时，您即受本协议的约束。您可以使用您提供或确认的邮箱、手机号码或者慕渊允许的其它方式作为登录手段进入慕渊展商秀官方网站。
    4.2.2您了解并同意，如您系在慕渊展商秀官方网站完成的注册程序，只要您注册成功，您即可以获得您的展商秀登录名（以下或称“账户”）。您可以通过您的展商秀登录名直接登录展商秀和慕渊集团旗下支持展商秀登录名登录的平台，无需另行设置账户。
    4.2.3由于您的账户关联您的信息及慕渊展商秀官方网站商业信息，您的账户仅限您本人/企业使用。未经慕渊同意，您直接或间接授权第三方使用您账户或获取您账户项下信息的行为无效。如慕渊根据您账户的使用行为等情况判断您账户的使用可能危及您的账户安全及/或慕渊展商秀官方网站信息安全的，慕渊可拒绝提供相应服务或终止本协议。
    4.3账户转让
    您的账户不得以任何方式转让，否则慕渊有权追究您的违约责任，且由此产生的相应责任均由您承担。
    4.4实名认证
    为使您更好地使用慕渊展商秀官方网站的各项服务，保障您的账户安全，慕渊可要求您按国家法律法规的规定完成实名认证。
    4.5注册信息管理
    4.5.1在完成注册或激活流程时，您应当按慕渊展商秀官方网站相应页面的提示准确完整地提供并及时更新您的信息，以使之真实、及时，完整和准确。在国家法律法规有明确规定要求慕渊作为平台服务提供者必须对用户的信息进行核实的情况下，慕渊将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。
    4.5.2如慕渊按您最后一次提供的信息与您联系未果、您未按慕渊的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及慕渊造成的全部损失与不利后果。慕渊可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部慕渊服务，除法律明确规定外慕渊对此不承担责任。
    4.5.3您设置的账户登录名及昵称不得违反国家法律法规及慕渊中国站规则的相应管理规定，否则慕渊可回收您的登录名及昵称，并按慕渊展商秀官方网站规则进行相应的处理。
    4.6账户安全 
    4.6.1您的账户为您自行设置并由您保管，慕渊任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开慕渊展商秀官方网站。账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，慕渊并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。
    4.6.2除慕渊存在过错外，您应对您账户项下的所有行为结果负责。
    4.6.3如发现任何未经授权使用您账户登录慕渊展商秀官方网站或其他可能导致您账户遭窃、遗失的情况，建议您立即通知慕渊，并授权慕渊将该信息同步给展商秀平台。您理解慕渊对您的任何请求采取行动均需要合理时间，且慕渊应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除慕渊存在法定过错外，慕渊不承担责任。
 
五、服务及规范
您有权在慕渊展商秀官方网站或微信客户端上享受展会项目建立、邀请函制作、展商管理、观众管理、展品管理、活动管理、互动管理、自定义设置、数据上传及下载等服务。慕渊展商秀提供的服务内容众多，具体您可登录慕渊展商秀官方网站浏览。
    5.1项目管理
    5.1.1通过展商秀官方网站创建展会项目，您需要对项目进行必要设置及基础设置，对项目的功能进行开启或关闭管理。项目结束后，对项目数据清空、项目删除的权力。5.1.2对项目的管理及设置，均在慕渊展商秀目前提供的平台服务版本框架范围内进行。如有超出平台服务框架范围的使用和设置，应及时与慕渊进行告知，否则，慕渊将有权对项目进行删除。
    5.1.3您应当确保对您在慕渊展商秀网站上发布的信息享有相应的权利，您不得在展商秀网站上发布或提供以下信息：
    （一）国家禁止或限制的；
    （二）侵犯他人知识产权或其它合法权益的；
    （三）展商秀官方网站规则、公告、通知或各平台与您单独签署的协议中已明确说明不适合在展商秀网站上提供的。
    5.2展商、展品、观众、活动的管理
    5.2.1 通过展商秀管理后台，对展商、观众、展品、活动进行批量导入、编辑、导出、删除、屏蔽、发送短信等操作及管理。
    5.2.2
    您有责任对您客户的注册信息、观众信息、展品及活动信息的真实性和合作性进行审核。如您或您的客户发布未经审核的违法违规信息，则该行为和意思表示产生的法律后果均由您承担。同时，慕渊可按照慕渊展商秀网站规则的相关规定以及国家法律规定，对您及您的客户发布的违规违法信息进行删除或屏蔽。
    5.2.3您应当确保您的客户在慕渊展商秀网站/微信客户端上发布的信息享有相应的权利，您的客户不得在展商秀网站上发布或提供以下信息：
    （一）国家禁止或限制的；
    （二）侵犯他人知识产权或其它合法权益的；
    （三）展商秀官方网站规则、公告、通知或各平台与您单独签署的协议中已明确说明不适合在展商秀网站上提供的。
    5.3 互动管理
    5.3.1您及您的客户有权通过展商秀管理后台，对邀请函、云名片、展品、活动等进行分享、围观、留言、点赞的管理。
    5.3.2当您或您的客户在展商秀微信平台进行互动时，请您务必仔细审核参与互动人员信息、互动内容等重要事项。如您或您的客户发布未经审核的违法违规信息，则该行为和意思表示产生的法律后果均由您承担。
    5.3.2您充分了解并同意，慕渊展商秀是一个展会互动营销平台，而展会行业平台或贸易平台，故您及您的客户在互动过程中关于询价、采购行为应当基于真实的贸易需求，不得存在对产品及/或服务实施恶意询价、采购等扰乱展商秀平台正常传播的行为。基于维护慕渊展商秀互动交流及传播的需要，慕渊展商秀发现上述情形时可主动执行关闭相关互动交流等操作。
    5.3.3您及您的客户有权在慕渊展商秀网站及微信客户端提供的互动平台中，对项目所展示的邀请函、云名片、展品/服务、活动等进行互动交流。您的所有评价行为应遵守慕渊展商秀网站规则的相关规定，互动内容不应包含任何污言秽语、色情低俗、广告信息及法律法规与本协议列明的其他禁止性信息。慕渊可按照慕渊展商秀网站规则的相关规定以及国家法律规定，对您及您的客户实施上述行为所产生的评价信息进行删除或屏蔽。
    5.4个性化服务
    5.4.1慕渊展商秀后台的服务框架提供基于自主开发技术的个性化服务。您有权在后台进行个性化设置及服务，并保证个性化服务的内容不包含法律法规与本协议列明的禁止性信息。
    5.4.2对超出我方提供的个性化服务及设置，您可选择告知我方协助，以满足个性化需求。
    5.5运维服务
    5.5.1慕渊展商秀提供关于展商秀操作、传播、个性化设置方面的运维服务及指导，提供免费客户服务解决您及您的客户提出的使用问题。
    5.5.2 对于超出我方针对展商秀的运维服务框架范围的其他技术服务，请您通过规定渠道向慕渊提起服务申请。慕渊将在24小时内给予书面或口头反馈，并提出解决方案。
 
六、费用
    6.1慕渊为慕渊展商秀向您提供的服务付出了大量的成本，除慕渊展商秀与您明示的收费业务外，慕渊向您提供的服务目前是免费的。如未来慕渊向您收取合理费用，慕渊会采取合理途径并提前通过法定程序以本协议约定的有效方式通知您，确保您有充分选择的权利。
    6.2您因进行交易、向慕渊获取有偿服务或接触慕渊服务器而发生的所有应纳税赋，以及相关硬件、软件、通讯、网络服务及其他方面的费用均由您自行承担。
 
七、责任限制
    7.1慕渊依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，慕渊并不承担相应的违约责任：
    （一）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
    （二）因电力供应故障、通讯网络故障等公共服务因素或第三人因素；
    （三）在慕渊已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
    7.2慕渊仅向您提供本协议约定之服务，您了解慕渊中国站上的信息系用户自行发布，且可能存在风险和瑕疵。慕渊将通过依照法律规定建立相关检查监控制度尽可能保障您在慕渊中国站的合法权益及良好体验。同时，鉴于慕渊中国站具备存在海量信息及信息网络环境下信息与实物相分离的特点，慕渊无法逐一审查产品及/或服务的信息，无法逐一审查交易所涉及的产品及/或服务的质量、安全以及合法性、真实性、准确性，对此您应谨慎判断。
    7.3 您理解并同意，在争议调处服务中，慕渊中国站的客服并非专业人士，仅能以普通人的认知对用户提交的凭证进行判断，慕渊不保证争议调处决定一定符合您的期望，除法律明确规定及存在故意或重大过失外，慕渊对争议调处决定不承担责任。

八、用户信息的保护及授权
    8.1个人信息的保护
    慕渊非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，在您使用慕渊提供的服务时，您同意慕渊按照在慕渊中国站上公布的隐私政策收集、存储、使用、披露和保护您的个人信息。慕渊希望通过隐私政策向您清楚地介绍慕渊对您个人信息的处理方式，因此慕渊建议您完整地阅读隐私政策，以帮助您更好地保护您的隐私权。
    8.2非个人信息的保证与授权
    8.2.1您声明并保证，您对您所发布的信息拥有相应、合法的权利。否则，慕渊可对您发布的信息依法或依本协议进行删除或屏蔽。
    8.2.2您应当确保您所发布的信息不包含以下内容：
    （一）违反国家法律法规禁止性规定的；
    （二）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
    （三）欺诈、虚假、不准确或存在误导性的；
    （四）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；
    （五）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；
    （六）存在可能破坏、篡改、删除、影响慕渊中国站任何系统正常运行或未经授权秘密获取慕渊中国站及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；
    （七）其他违背社会公共利益或公共道德或依据相关慕渊中国站协议、规则的规定不适合在慕渊中国站上发布的。
    8.2.3对于您提供、发布及在使用慕渊服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，在法律规定的保护期限内您免费授予慕渊及其关联公司、展商秀服务获得全球排他的许可使用权利及再授权给其他第三方使用并可以自身名义对第三方侵权行为取证及提起诉讼的权利。您同意慕渊及其关联公司、展商秀服务存储、使用、复制、修订、编辑、发布、展示、翻译、分发您的非个人信息或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。
    8.2.4为方便您使用展商秀、会展人等其他相关服务，您授权慕渊将您在账户注册和使用慕渊服务过程中提供、形成的信息传递给阿里平台、展商秀等其他相关服务提供者，或从阿里平台、展商秀等其他相关服务提供者获取您在注册、使用相关服务期间提供、形成的信息。
     
九、用户的违约及处理
    9.1违约认定
    发生如下情形之一的，视为您违约：
    （一）使用慕渊服务时违反有关法律法规规定的；
    （二）违反本协议或本协议补充协议（即本协议第3.2条）约定的。
    为适应电子商务发展和满足海量用户对高效优质服务的需求，您理解并同意，慕渊可在慕渊中国站规则中约定违约认定的程序和标准。如：慕渊可依据您的用户数据与海量用户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。
    9.2违约处理措施
    9.2.1您在慕渊中国站上发布的信息构成违约的，慕渊可根据相应规则立即对相应信息进行删除、屏蔽处理、监管。
    9.2.2您在慕渊中国站上实施的行为，或虽未在慕渊中国站上实施但对慕渊中国站及其用户产生影响的行为构成违约的，慕渊可依据相应规则对您执行中止向您提供部分或全部服务等处理措施。如您的行为构成根本违约的，慕渊可关闭您的账户，终止向您提供服务。
    9.2.3慕渊可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在慕渊中国站上予以公示。
    9.3赔偿责任
    9.3.1如您的行为使慕渊及/或其关联公司、展商秀服务等遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿慕渊及/或其关联公司、展商秀服务的上述全部损失。
    9.3.2如您的行为使慕渊及/或其关联公司、展商秀服务遭受第三人主张权利，慕渊及/或其关联公司、展商秀服务可在对第三人承担金钱给付等义务后就全部损失向您追偿。
    9.4特别约定
    9.4.1如您向慕渊及/或其关联公司的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽谈范畴的利益，则可视为您存在商业贿赂行为。发生上述情形的，慕渊可按照慕渊中国站规则进行相应处理，并经提前通知后终止与您的所有合作并向您收取违约金及/或赔偿金，该等金额以慕渊因您的贿赂行为而遭受的经济损失和商誉损失作为计算依据。
    9.4.2如您因严重违约导致慕渊终止本协议时，出于维护平台秩序及保护其他用户合法权益的目的，慕渊及/或其关联公司可对与您在其他协议项下的合作采取中止甚或终止协议的措施，并以本协议约定的有效方式通知您。
    9.4.3如慕渊与您签署的其他协议及慕渊及/或其关联公司、展商秀服务与您签署的协议中明确约定了对您在本协议项下合作进行关联处理的情形，则慕渊出于维护平台秩序及保护其他用户合法权益的目的，可在收到指令时中止甚至终止协议，并以本协议约定的有效方式通知您。
十、协议的变更
    10.1慕渊可根据国家法律法规变化及维护市场秩序、保护用户合法权益需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过法定程序并以本协议约定的有效通知方式通知您。
    10.2如您不同意变更事项，您有权于变更事项确定的生效日前联系慕渊反馈意见。如反馈意见得以采纳，慕渊将酌情调整变更事项。如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用慕渊服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用慕渊服务，则视为您同意已生效的变更事项。
 
十一、有效通知
    11.1有效联系方式
    您在注册成为慕渊中国站用户，并接受慕渊服务时，您应该向慕渊提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被有效联系的状态。
    慕渊将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。
    11.2通知的送达
    11.2.1慕渊通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在慕渊中国站公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。
    11.2.2对于在慕渊中国站上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在慕渊中国站注册、更新时提供的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。
    您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。
    您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。
    你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
 
十二、协议终止
    12.1协议终止的情形
    12.1.1您有权通过以下任一方式终止本协议：
    （一）在满足慕渊中国站要求的账户注销条件时您通过网站自助服务注销您的账户的；
    （二）变更事项生效前您停止使用慕渊服务并明示不愿接受变更事项的；
    （三）您明示不愿继续使用慕渊服务，且符合慕渊中国站要求的终止条件的。
    12.1.2出现以下情况时，慕渊可以本协议约定的有效方式通知您终止本协议：
    （一）您的实名认证身份无效、不再合法存续或无法有效核实；
    （二）您违反本协议约定，慕渊依据违约条款终止本协议的；
    （三）您盗用他人账户、发布违禁信息、欺诈、售假、扰乱市场秩序、采取不正当手段牟利等行为，慕渊依据慕渊中国站规则对您的账户予以关闭的；
    （四）除上述情形外，因您多次违反慕渊中国站规则相关规定且情节严重，慕渊依据慕渊中国站规则对您的账户予以关闭的；
    （五）您的账户被慕渊依据本协议回收的；
    （六）您在展商秀平台有欺诈、发布或侵犯他人合法权益或其他严重违法违约行为的；
    （七）慕渊基于合理理由相信您的行为可能会使您、慕渊中国站用户等相关方发生严重损害或产生法律责任；
    （八）其它应当终止服务的情况。
    12.2协议终止后的处理
    12.2.1本协议终止后，除法律有明确规定外，慕渊无义务向您或您指定的第三方披露您账户中的任何信息。
    12.2.2本协议终止后，慕渊仍享有下列权利：
    （一）继续保存您留存于慕渊中国站的本协议第八条所列的各类信息；
    （二）对于您过往的违约行为，慕渊仍可依据本协议向您追究违约责任。
 
十三、法律适用、管辖及其他
    13.1本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国大陆地区法律；如无相关法律规定的，则应参照商业惯例和（或）行业惯例。 
    13.2您与慕渊仅为独立订约人关系。本协议无意结成或创设任何代理、合伙、合营、雇佣与被雇佣或特性授权与被授权关系。 
    13.3除双方另有约定外，您同意慕渊因经营业务需要有权将本协议项下的权利义务就部分或全部进行转让，并采取合理途径提前通过法定程序以本协议约定的有效方式通知您。 
    13.4因本协议或慕渊服务所引起或与其有关的任何争议，由慕渊与您协商解决。协商不成时，任何一方均可向慕渊住所地人民法院提起诉讼。
    13.5倘若本协议任何条款被裁定为无效或不可强制执行，该项条款应被撤销，而其余条款应予遵守和执行。条款标题仅为方便参阅而设，并不以任何方式界定、限制、解释或描述该条款的范围或限度。慕渊未就您或其他人士的某项违约行为采取行动，并不表明慕渊撤回就任何继后或类似的违约事件采取动的权利。
      </pre>
      <div class="f-tac">
        <Button type="primary" size="large" @click="agree=true;showModel=false">接受</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "exhibition-register",
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formInline.password) {
        callback(new Error("两次密码不匹配!"));
      } else {
        callback();
      }
    };
    return {
      bodyHeight: "800px",
      loading: false,
      agree: true,
      showModel: false,
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      formInline: {
        // form双向绑定
        name: "",
        mobile: "",
        captcha: "",
        password: "", 
        repassword: ""
      },
      ruleInline: {
        // 效验规则
        name: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback("用户为必填选项");
              } else if (/^[a-zA-Z0-9_-]{4,16}$/.test(value)) {
                callback();
              } else {
                callback("用户名为4到16位（字母，数字，下划线，减号）");
              }
            },
            trigger: "blur"
          }
        ],
        mobile: validator.phone,
        captcha: [
          {
            required: true,
            message: "验证码为必填选项",
            trigger: "blur"
          }
        ],
        password: validator.password,
        repassword: [
          {
            required: true,
            validator: validatePassCheck,
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 注册";
    this.bodyHeight = window.innerHeight ? window.innerHeight + "px" : "800px";
  },
  methods: {
    ...mapMutations({
      setUser: "setUser",
      setToken: "setToken",
      setTokenTime: "setTokenTime",
      setLogin: "setLogin"
    }),
    ...mapActions({
      getUser: "loginModule/getUser",
      getToken: "loginModule/getToken",
      getMsgCode: "loginModule/getMsgCode",
      validateMsgCode: "loginModule/validateMsgCode",
      registerExhibition: "registerModule/registerExhibition"
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!this.agree) {
        this.$Message.warning("注册前需确认注册条款");
        return;
      }
      let codeValid = await this.validCode();
      if (!codeValid) return;
      let formData = {
        UserName: form.name,
        PhoneNumber: form.mobile,
        Password: form.password,
        ConfirmPassword: form.repassword
      };
      this.loading = true;
      setTimeout(c => {
        this.loading = false;
      }, 5000);
      let user = await this.registerExhibition(formData); 
      if (user) {
        this.loading = false;
        this.$Message.success("注册账号成功，可使用用户名登录！");
        this.getLoginInfo();
      }
      this.loading = false;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    getCaptcha() {
      this.$refs.formInline.validateField("mobile", val => {
        if (val !== "") return;
        this.downTime();
      });
    },
    async downTime() {
      const valid = await this.getMsgCode(this.formInline.mobile);
      console.log(valid);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async validCode() {
      // 验证code
      if (!this.formInline.captcha) return false;
      let valid = this.validateMsgCode({
        Phone: this.formInline.mobile,
        Code: this.formInline.captcha
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        this.$Message.error(valid.errors[0].description);
        return false;
      }
      return true;
    },
    async getLoginInfo(opt) {
      let form = this.formInline;
      let formData = {
        grant_type: "password",
        client_id: "cloud.exhibition",
        client_secret: "secret",
        username: form.name,
        password: form.password,
        scope: "synair offline_access"
      };
      let tokenData = await this.getToken(formData);
      if (tokenData) {
        this.$Message.success("登录成功");
        const token = tokenData.access_token + "";
        this.setToken(token);
        this.setTokenTime(tokenData.expires_in * 1000 + new Date().getTime());
        let user = await this.getUser();
        this.setLogin(true);
        setTimeout(() => {
          this.$router.push("/exhibition/register-company");
        }, 1000);
      }
    }
  }
};
</script>

<style scoped lang='scss'>
.register-form {
  font-size: 14px;
  width: 500px;
  margin: 0 auto;
  .rf {
    &-title {
      font-size: 20px;
      color: #333;
      padding: 60px 0 44px;
      text-align: center;
    }
  }
  .form-code-item {
    .ivu-btn {
      margin-left: 10px;
      width: calc(100% - 10px);
    }
  }
  .form-tip-info {
    color: #1890ff;
    cursor: pointer;
  }
}

.layout-body {
  height: 100%;
  background: #fff;
}
.layout-header-bar {
  display: flex;
  background: #002140;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.head-logo {
  height: 64px;
  padding-top: 16px;
  padding-left: 19px;
}
.head-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.head-btn {
  font-size: 18px;
  color: #ededed;
  padding-right: 45px;
  display: inline-block;
  cursor: pointer;
}
</style>